import { sendGetRequest } from "services/apiService";

const fetchDeployedVersion = () => sendGetRequest<string | null>("/version");

export default fetchDeployedVersion;
